import { Controller } from '@hotwired/stimulus';
import { isEqual } from 'lodash';

// Connects to data-controller="option-filter"
export default class extends Controller {
  static targets = ['checkbox', 'button', 'text'];
  static values = {
    originalText: String,
    activeText: String,
    fixedActiveText: Object,
    checked: Array,
  };

  connect() {
    this.connected = true;
  }

  checkedValueChanged(newValue, oldValue) {
    this.checkboxTargets.forEach(
      (t) => (t.checked = newValue.includes(t.value)),
    );

    this.buttonTarget.setAttribute(
      'data-active',
      newValue.length ? 'true' : 'false',
    );

    this.textTarget.innerText = this.buttonText();

    // This callback is executed once before this.connect is called. At this point, oldValue
    // is either undefined and newValue is the default [] (if the HTML doesn't pass a value), or
    // oldValue is [] and new value is some array (if the HTML does pass a value). Because of this
    // somewhat strange behavior, we can't rely on oldValue === undefined to avoid requesting
    // unnecessary submits.
    if (!this.connected) {
      return;
    }

    if (!isEqual(newValue, oldValue)) {
      this.element.closest('form').requestSubmit();
      this.dispatch('changed');
    }
  }

  setChecked() {
    this.checkedValue = this.checkboxTargets
      .filter((t) => t.checked)
      .map((t) => t.value);
  }

  buttonText() {
    const numOfChecked = this.checkedValue.length;

    if (numOfChecked === 0) {
      return this.originalTextValue;
    } else if (this.hasFixedActiveTextValue) {
      return this.fixedActiveTextValue[this.checkedValue[0]];
    } else {
      return `${this.activeTextValue} (${numOfChecked})`;
    }
  }

  reset() {
    this.checkedValue = [];
  }
}
